<template>
	<v-form
		ref="form"
		v-model="valid"
		@submit.prevent="submit"
	>
		<v-layout
			row
			wrap
			ma-0
			justify-center
			align-center
		>
			<v-flex
				py-0
				class="text-xs-left"
				:class="{ 'pr-5': $vuetify.breakpoint.smAndUp }"
			>
				<v-text-field
					ref="name"
					v-model="name"
					:rules="[validate.maxNotRequired(name, 75), validateNotEmpty(), validateReport()]"
					:required="true"
					:autofocus="editReport ? false : true"
					name="Name"
					label="Report Name"
				/>
				<v-menu
					v-model="dateMenu"
					:close-on-content-click="false"
					lazy
					transition="scale-transition"
					offset-y
					full-width
					max-width="290px"
					min-width="290px"
				>
					<v-text-field
						slot="activator"
						:rules="[validateDate]"
						v-model="date"
						:label="dateLabel"
						readonly
					/>
					<v-date-picker
						v-model="date"
						show-current
						no-title
						@input="closeDateMenu"
					/>
				</v-menu>
				<v-textarea
					v-model="description"
					name="description"
					label="Description"
				></v-textarea>
			</v-flex>
			<v-flex
				shrink
				class="text-xs-center"
			>
				<v-layout column>
					<v-btn
						:disabled="!valid"
						ripple
						color="primary"
						type="submit"
					>
						Submit
					</v-btn>
					<slot name="buttons"/>
				</v-layout>
			</v-flex>
		</v-layout>
	</v-form>
</template>

<script>
import Validation from '@/mixins/Validation';
import { Report } from '@/models/Report';

export default {
	mixins: [Validation],
	props: {
		editReport: { type: Object, default: null },
	},
	data() {
		return {
			existingId: -1,
			valid: true,
			name: '',
			description: '',
			date: null,
			dateMenu: false,
			dateLabel: 'Date *',
			existingReports: [],
		};
	},
	created() {
		this.existingReports = this.$store.get('reports/all');
		
		if (this.editReport) {
			this.existingId = this.editReport.id;
			this.name = this.editReport.name;
			this.description = this.editReport.description;
			this.date = this.editReport.date;
			if (this.date === null) {
				this.dateLabel = 'Date';
			}
			this.existingReports = this.existingReports.filter(o => o.id !== this.existingId);
		}
		else {
			const d = new Date();
			const month = (`0${d.getMonth() + 1}`).slice(-2);
			const day = (`0${d.getDate()}`).slice(-2);
			const year = d.getFullYear();

			this.date = `${year}-${month}-${day}`;
		}
	},
	methods: {
		submit() {
			if (this.editReport) {
				this.updateReport(this.editReport);
			}
			else {
				this.newReport();
			}
		},
		updateReport(report) {
			const oldName = report.name;
			report.name = this.name;
			report.description = this.description;
			report.date = this.date;
			this.$emit('update-report', report, oldName);
		},
		newReport() {
			const report = new Report();
			report.name = this.name;
			report.description = this.description;
			report.date = this.date;
			this.$emit('new-report', report);
		},
		validateReport() {
			let result = true;

			this.existingReports.each((report) => {
				if (report.date === this.date && report.name.toLowerCase().trim() === this.name.toLowerCase().trim()) {
					result = 'A report with this name/date combination already exists';
					// break loop
					return false;
				}
			});
			return result;
		},
		validateNotEmpty() {
			if (this.name.trim() === '' && !this.date) {
				return 'Date and name cannot be empty';
			}
			return true;
		},
		closeDateMenu() {
			this.dateMenu = false;
			// Guarantee v-model has been populated with updated value
			this.$nextTick(() => {
				this.$refs.name.validate();
			});
		},
	},
};
</script>


<style lang="scss">
.markdown-container {
	@import "~simplemde/dist/simplemde.min";
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	.markdown-editor-container {
		display: flex;
		flex-direction: column;
	}
	.toolbar-item--hidden {
		visibility: hidden;
		min-width: 0px !important;
		height: 0px !important;
	}
}
.editor-toolbar {
	display: flex;
	justify-content: center;
	text-align: center !important;
	width: 100% !important;
	border: none !important;
	border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
	opacity: 1 !important;
	&::after {
		margin: 0 !important;
	}
	&::before {
		margin: 0 !important;
	}
	a {
		width: auto !important;
		min-width: 30px;
		&:hover {
			border-color: transparent !important;
		}
	}
	a.active {
		border-color: transparent !important;
		color: #1d97c1 !important;
	}
}
.custom-toolbar-item:before {
	content: attr(title);
	width: 100px;
	margin: 0 3px;
}
.CodeMirror {
	border: none !important;
	width: 100%;
	flex-grow: 1;
	// height: 100% !important;
	// min-height: 100% !important;
}
</style>

